import React, { useEffect, useState } from "react";
import shortid from "shortid";

import useHttp from "../../../hooks/useHttp";
import { PENDING_BANK_PAYMENT_REQUEST } from "../../../utils/api-ends";
import LoaderImg from "../../../assets/media/loader.gif";

const BankTransactionHistory = () => {
  const [transactionHistory, setTransactionHistory] = useState([]);
  const { isLoading, sendRequests } = useHttp();

  useEffect(() => {
    const response = (data) => {
      setTransactionHistory(data);
    };

    sendRequests(
      {
        url: PENDING_BANK_PAYMENT_REQUEST,
      },
      response
    );
  }, [sendRequests])

  return (
    <section>
      <div className="container theme-section">
        <h1 className="tr-title text-center"> Load Transaction History </h1>

        {isLoading ? (
          <div className="d-flex justify-content-center">
            <img style={{ width: "35px" }} src={LoaderImg} alt="" />
          </div>
        ) : (
          <div className="transaction-table-area">
            <div className="transaction-table">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">
                      Transaction <br /> Receipt Image
                    </th>
                    <th scope="col">Payment date</th>
                    <th scope="col">Request time </th>
                    <th scope="col">Bank Name</th>
                    <th scope="col">Bank Branch Name</th>
                    <th scope="col">Transaction Id</th>
                    <th scope="col">
                      Bank Ac <br /> Holder Name
                    </th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {transactionHistory.map((transaction) => (
                    <tr key={shortid.generate()}>
                      <td>
                        <div className="transaction-bank-receipt">
                          <img
                            src={transaction.transaction_receipt_image_url}
                            alt=""
                          />
                        </div>
                      </td>
                      <td> {transaction.payment_date} </td>
                      <td> {transaction.request_time} </td>
                      <td> {transaction.bank_name} </td>
                      <td> {transaction.bank_branch_name} </td>
                      <td> {transaction.transaction_id} </td>
                      <td> {transaction.bank_account_holder_name} </td>
                      <td>
                        <div className="multiple-btn">
                          <button>Cancel</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default BankTransactionHistory;
